const ApiRoutes = {
  CREATE_ADMIN_USER: `/create/new/user`,
  GET_ADMIN_USERS: `/get/all/users`,
  GET_ADMIN_USER_BY_ID: `/get/user/`,
  UPDATE_ADMIN_USER: `/update/user/`,
  UPDATE_ADMIN_USER_STATUS: `/update/user/status/`,
  DELETE_ADMIN_USER: `/delete/user/`,

  UPLOAD_IMAGE: "/upload/image",

  LOGIN: `/auth/login`,
  VALIDATE_USER: `/validate/user`,

  CREATE_TOP_DEAL: `/create/deal`,
  GET_TOP_DEALS: `/get/all/deal`,
  GET_TOP_DEAL_BY_ID: `/get/deal/`,
  UPDATE_TOP_DEAL: `/update/deal/`,
  DELETE_TOP_DEAL: `/delete/deal/`,

  CREATE_VENDOR: "/create/vendor",
  GET_VENDORS: `/get/all/vendors`,
  GET_VENDOR_BY_ID: `/get/vendor/`,
  UPDATE_VENDOR: `/update/vendor/`,
  DELETE_VENDOR: `/delete/vendor/`,

  CREATE_PRODUCT: "/create/product",
  GET_PRODUCTS: `/get/all/products`,
  GET_PRODUCT_BY_ID: `/get/product/`,
  UPDATE_PRODUCT: `/update/product/`,
  DELETE_PRODUCT: `/delete/product/`,

  CREATE_CART: "/cart/add",
  GET_CARTS: `/get/cart`,
  UPDATE_CART: `/cart/update/`,
  REMOVE_CART_ITEM: `/cart/remove/`,
  CLEAR_CART: `/cart/clear`,
  MERGE_CART: `/cart/merge`,

  CREATE_CATEGORY: `/create/new/category`,
  CREATE_SUB_CATEGORY: `/add/sub-category/to/`,
  GET_ALL_CATEGORY: "/get/all/categories",
  GET_SUB_CATEGORY_BY_CATEGORY: "/get/sub-categories/by/",
  UPDATE_CATEGORY: `/update/category/by/`,
  DELETE_CATEGORY: `/delete/category/by/`,
  DELETE_SUB_CATEGORY: "/delete/subcategory/by/",
};

export default ApiRoutes;
